<script>
  import { tick, afterUpdate, onMount } from "svelte";
  import Chart from "chart.js";
  import FoodSearch from "./FoodSearch.svelte";
  import Navbar from "./Navbar.svelte";

  let dateIndex = new Date().toLocaleDateString();
  let foodList = [];
  let chartCanvas = null;

  onMount(async () => {
    chartCanvas = document.getElementById("myChart");
    changeDate();
    await tick();
    updateChart();
  });

  afterUpdate(() => {
    if (ctx) updateChart();
  });

  function changeDate() {
    foodList = localStorage.getItem(dateIndex)
      ? JSON.parse(localStorage.getItem(dateIndex))
      : [];
  }

  const addFood = event => {
    const food = event.detail.food;
    foodList = [...foodList, food];
    localStorage.setItem(dateIndex, JSON.stringify(foodList));
  };

  $: foodDataList = [foodTotal.carb, foodTotal.fat, foodTotal.protein];

  $: foodTotal = foodList.reduce(
    (acc, cur) => {
      window.item = cur;
      acc.fat +=
        (cur.amount / 100) * parseFloat(cur["Fett (g)"].replace(",", "."));
      acc.protein +=
        (cur.amount / 100) * parseFloat(cur["Protein (g)"].replace(",", "."));
      acc.carb +=
        (cur.amount / 100) *
        parseFloat(cur["Kolhydrater (g)"].replace(",", "."));
      acc.calories += (cur.amount / 100) * cur["Energi (kcal)"];

      return acc;
    },
    { fat: 0.0, protein: 0, carb: 0, calories: 0 }
  );

  let ctx = null;
  function updateChart() {
    if (!ctx) {
      window.ctx = ctx = new Chart(chartCanvas, {
        type: "pie",
        data: {
          labels: ["Kolhydrater", "Fett", "Protein"],
          datasets: [
            {
              label: "# of Votes",
              data: foodDataList,
              backgroundColor: [
                "rgba(255, 99, 132, 0.2)",
                "rgba(54, 162, 235, 0.2)",
                "rgba(255, 206, 86, 0.2)"
              ],
              borderColor: [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
                "rgba(255, 206, 86, 1)"
              ],
              borderWidth: 1
            }
          ]
        },
        options: {}
      });
    } else {
      ctx.data.datasets[0].data = foodDataList;
      ctx.update();
    }
  }
</script>

<Navbar />
<div class="container" style="padding-top: 40px">
  <div class="row">
    <div class="col-md-3 offset-md-9">
      <label for="intags-dag">Datum:</label>
      <input
        id="intags-dag"
        on:input={changeDate}
        class="form-control"
        type="date"
        bind:value={dateIndex} />
    </div>
  </div>
  <div class="row">
    <div class="col-md-4">
      <FoodSearch on:addFood={addFood} />

    </div>
    <div class="col-md-8">

      <h4 class="mt-4">Intag</h4>
      <div class="row">
        <div class="col-md-4">
          {#if foodList && foodList.length > 0}
            <ul>
              {#each foodList as food}
                <li>{food.amount}{food.unit} {food.Livsmedelsnamn}</li>
              {/each}
            </ul>
          {/if}
        </div>
        <div style="text-align: right" class="col-md-8">
          <div style="display: {foodTotal.calories ? '' : 'none'}">
            <canvas id="myChart" />
          </div>
          <h6>Totalt: {foodTotal.calories.toFixed(1)}</h6>
          <p>
            <span>Kolhydrater: {foodTotal.carb.toFixed(1)}</span>
            <span>Protein: {foodTotal.protein.toFixed(1)}</span>
            <span>Fett: {foodTotal.fat.toFixed(1)}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
